import { __decorate } from "tslib";
import { css, html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { styleMap } from 'lit/directives/style-map.js';
import { classMap } from 'lit/directives/class-map.js';
import { getBasePath } from '../../utilities/base-path.js';
import componentStyles from '../../styles/component.styles.js';
import { ICON_TYPES } from './constants/IconConstants.js';
import { FONT_SIZES } from '../../internal/constants/styleConstants.js';
export default class ArcIcon extends LitElement {
    constructor() {
        super(...arguments);
        this.name = ICON_TYPES.fire;
        this.label = '';
        this.size = FONT_SIZES.medium;
        this.rotation = 0;
        this.spinning = false;
    }
    render() {
        const DEFAULT_PATH = `${getBasePath()}/assets/icons.svg`;
        const styles = {
            transform: this.rotation ? `rotate(${this.rotation}deg)` : null,
            height: `var(--arc-font-size-${this.size})`,
            width: `var(--arc-font-size-${this.size})`,
        };
        return html `
      <svg
        id="icon"
        class=${classMap({ spinning: this.spinning })}
        style=${styleMap(styles)}
        role=${ifDefined(this.label ? 'img' : undefined)}
        aria-label=${ifDefined(this.label ? this.label : undefined)}
        aria-hidden=${ifDefined(this.label ? undefined : 'true')}
      >
        <use href="${DEFAULT_PATH}#arc-${this.name}" xlink:href="${DEFAULT_PATH}#arc-${this.name}" />
      </svg>
    `;
    }
}
ArcIcon.tag = 'arc-icon';
ArcIcon.styles = [
    componentStyles,
    css `
      :host {
        display: flex;
        --icon-color-primary: inherit;
        --icon-color-secondary: currentColor;
      }

      #icon {
        display: inline-block;
        color: var(--icon-color-primary);
        line-height: 1;
        flex-shrink: 0;
        max-width: initial;
      }

      #icon use {
        fill: var(--icon-color-secondary);
        stroke: var(--icon-color-secondary);
      }

      /* Caps/Corners */
      #icon use {
        --icon-stroke-linecap-butt: butt;
        stroke-miterlimit: 10;
        stroke-linecap: square;
        stroke-linejoin: miter;
      }

      .stroke-round use {
        --icon-stroke-linecap-butt: round;
        stroke-linecap: round;
        stroke-linejoin: round;
      }

      /* Animations */
      .spinning {
        animation: icon-spin var(--arc-transition-x-slow) infinite linear;
      }

      @keyframes icon-spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `,
];
__decorate([
    property({ type: String, reflect: true })
], ArcIcon.prototype, "name", void 0);
__decorate([
    property({ type: String })
], ArcIcon.prototype, "label", void 0);
__decorate([
    property({ type: String, reflect: true })
], ArcIcon.prototype, "size", void 0);
__decorate([
    property({ type: Number })
], ArcIcon.prototype, "rotation", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], ArcIcon.prototype, "spinning", void 0);
